import {
  Component,
  input,
  InputSignal,
  output,
  OutputEmitterRef,
} from '@angular/core';
import { TranscriptionSegment } from '../../models/translated-segment.model';
import { ChronoPipe } from '../../pipes/chrono.pipe';

@Component({
  selector: 'app-transcription-segment-element',
  imports: [ChronoPipe],
  template: `<div class="chip">
      {{ segment().start | chrono }}
    </div>
    <div class="text">{{ segment().text }}</div>`,
  styleUrl: './transcription-segment-element.component.scss',
  host: {
    '[style.--main-color]': 'color()',
    '(click)': 'onClick.emit(segment())',
  },
})
export class TranscriptionSegmentElementComponent {
  segment: InputSignal<TranscriptionSegment> = input.required();
  color: InputSignal<string> = input.required();
  onClick: OutputEmitterRef<TranscriptionSegment> = output();
}
